import { Helmet } from 'react-helmet-async';
// @mui
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Divider,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
// components
import { useSettingsContext } from '../../../components/settings';
import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TableHeader from 'src/components/Indicators/table/Header';
import TableRow from 'src/components/Indicators/table/TableRow';
import { useLoadImpacts, useLoadProgramxVolets } from 'src/data/impact/queries/impact-queries';
import Iconify from 'src/components/iconify';
import DetailsHeader from 'src/components/Indicators/details/DetailsHeader';
import CustomBreadcrumbsActivity from 'src/components/activity/links/Breadcumbs';
import DetailsRowVolet2 from 'src/components/Indicators/details/DetailsRowVolet2';
import DetailsRowVolet3 from 'src/components/Indicators/details/DetailsRowVolet3';
import DetailsRowVolet4 from 'src/components/Indicators/details/DetailsRowVolet4';
import DetailsProgram from 'src/components/Indicators/details/DetailsProgram';
import DetailsRowsVolet1 from 'src/components/Indicators/details/DetailsRowVolet1';
import { IndicateurTitle } from '../indicateurs/constants';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  height: '80vh',
  overflow: 'scroll',
  bgcolor: 'background.paper',
  border: '2px solid #eee',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

const titleNames = {
  "program" : "Programme",
  "volet1" : "PAGECTE",
  "volet2" : "LoCAL",
  "volet3" : "Greenov'i",
  "volet4":"ARESSE"

}
// ----------------------------------------------------------------------

export default function IndicatorsPage() {
  const {
    data: programXVoletsData,
    isLoading: programxvoletsloading,
    isError,
  } = useLoadProgramxVolets();
  const programxvolets = programXVoletsData?.results;
  const [program, setProgram] = useState<string | undefined>(undefined);
  const [volet, setVolet] = useState<string | undefined>(undefined);
  const { data, isLoading } = useLoadImpacts({
    program: program,
    volet: volet,
  });
  const { themeStretch } = useSettingsContext();
  const [title, setTitle] = useState('program');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const reuslts = data?.results;
  useEffect(() => {
    if (programxvolets && programxvolets.length > 0) {
      setProgram(programxvolets[0].id);
    }
  }, [programxvolets]);
  if (isLoading || programxvoletsloading)
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: 'tranparent',
        }}
      >
        <CircularProgress
          size={60}
          thickness={5}
          sx={{
            color: 'primary',
            mb: 2,
          }}
        />
        <Typography variant="h6" sx={{ color: 'primary' }}>
          Chargement...
        </Typography>
      </Box>
    );

  if (isError) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: 'tranparent',
        }}
      >
        <Typography variant="h6" sx={{ color: 'primary' }}>
          En maintenance maintenant...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title> Indicators | File app</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : 'xl'}>
        <CustomBreadcrumbsActivity
          heading="Suivi des indicateurs"
          links={[
            {
              name: 'Programme',
              action: () => {
                setVolet(undefined);
                setTitle('program');
                setProgram(programxvolets[0].id);
              },
              isActive: program == programxvolets[0].id,
            },
            {
              name: 'Volet 1',
              action: () => {
                setVolet(programxvolets.filter((v: any) => v.name == 'volet1')[0].id);
                setProgram(undefined);
                setTitle('volet1');
              },
              isActive: volet == programxvolets.filter((v: any) => v.name == 'volet1')[0].id,
            },
            {
              name: 'Volet 2',
              action: () => {
                setVolet(programxvolets.filter((v: any) => v.name == 'volet2')[0].id);
                setProgram(undefined);
                setTitle('volet2');
              },
              isActive: volet == programxvolets.filter((v: any) => v.name == 'volet2')[0].id,
            },
            {
              name: 'Volet 3',
              action: () => {
                setVolet(programxvolets.filter((v: any) => v.name == 'volet3')[0].id);
                setProgram(undefined);
                setTitle('volet3');
              },
              isActive: volet == programxvolets.filter((v: any) => v.name == 'volet3')[0].id,
            },
            {
              name: 'Volet 4',
              action: () => {
                setVolet(programxvolets.filter((v: any) => v.name == 'volet4')[0].id);
                setProgram(undefined);
                setTitle('volet4');
              },
              isActive: volet == programxvolets.filter((v: any) => v.name == 'volet4')[0].id,
            },
          ]}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box className="flex items-center  mb-1 gap-2">
            <Alert icon={false} className="border-none" severity="info">
              {IndicateurTitle[title as keyof typeof IndicateurTitle]}
            </Alert>
          </Box>
        </LocalizationProvider>
        <Divider />
        <div className="w-full h-full overflow-auto flex  gap-1">
          {/* HEADER PART */}
          <Box className="w-full  min-h-[450px] min-w-[1300px] flex flex-col gap-1">
            <TableHeader title={titleNames[title as keyof typeof titleNames]} />
            {/* BODY PART */}
            {reuslts &&
              reuslts.length > 0 &&
              reuslts.map((i: any, index: number) => (
                <TableRow isVolet={volet != undefined} key={index} data={i} />
              ))}
          </Box>

          <IconButton
            size="small"
            color="inherit"
            onClick={handleOpen}
            sx={{
              color: 'text.secondary',
              height: '50px',
              width: '50px',
              marginTop: '10px',
            }}
          >
            <Iconify icon="ci:show" width={16} />
          </IconButton>
        </div>
      </Container>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-full overflow-scroll flex flex-col items-center justify-center">
            <DetailsHeader />
            {title == 'program' && <DetailsProgram />}
            {title == 'volet1' && <DetailsRowsVolet1 />}
            {title == 'volet2' && <DetailsRowVolet2 />}
            {title == 'volet3' && <DetailsRowVolet3 />}
            {title == 'volet4' && <DetailsRowVolet4 />}
          </div>
        </Box>
      </Modal>
    </>
  );
}